"use strict";
var $dyn;
(function ($dyn) {
    var ui;
    (function (ui) {
        /**
         * Update the browser query string.
         * Do not use the reserved keys {@link $dyn.shell.QueryStringKeys}.
         * @param key URL parameter to be added or updated.
         * @param value New value for the parameter.  Provide null or undefined to delete an existing parameter.
         */
        function updateQueryStringParameter(key, value) {
            if (!key) {
                $dyn.logError("Shell: updateQueryStringParameter requires a key parameter.");
            }
            $dyn.shell.browserHistory.pendingUrlParameters[key] = value;
            $dyn.shell.browserHistory.urlParameterPending(true);
        }
        ui.updateQueryStringParameter = updateQueryStringParameter;
        /**
         * Retrieve the browser query parameter value for a particular key.
         * @param key URL parameter to be retrieved
         * @returns Value for the parameter.
         */
        function getQueryStringParameter(key) {
            if (!key) {
                $dyn.logError("Shell: getQueryStringParameter requires a key parameter.");
            }
            return $dyn.util.location.query[key];
        }
        ui.getQueryStringParameter = getQueryStringParameter;
    })(ui = $dyn.ui || ($dyn.ui = {}));
    var shell;
    (function (shell) {
        /**
         * @file Shell subcomponent for managing the single page application browser experience
         */
        var browserHistory;
        (function (browserHistory) {
            // flags
            // using inapp back button will switch this
            browserHistory.backNavigationInitiatedByBrowser = true;
            // we need to keep the initializing state to allow us to use the browser back button to close dialogs.
            browserHistory.duplicateRecord = false;
            browserHistory.goingBack = false;
            browserHistory.goToPreviousFormPending = $dyn.observable(false);
            browserHistory.newStatePending = $dyn.observable(false);
            browserHistory.pivotEvaluationPending = 0;
            browserHistory.revert = false;
            browserHistory.undo = false;
            browserHistory.updateQuery = false;
            browserHistory.urlParameterPending = $dyn.observable(false);
            browserHistory.waitForPopStateHandler = $dyn.observable(false);
            // data
            browserHistory.activePivots = {};
            browserHistory.navigationHistory = $dyn.observableArray([]);
            browserHistory.newHistoryState = {};
            browserHistory.pendingFormCloseStates = []; // queue
            browserHistory.pendingUrlParameters = {};
            function init() {
                // flags
                browserHistory.backNavigationInitiatedByBrowser = true;
                browserHistory.duplicateRecord = false;
                browserHistory.goingBack = false;
                browserHistory.newStatePending(false);
                browserHistory.pivotEvaluationPending = 0;
                browserHistory.goToPreviousFormPending(false);
                browserHistory.revert = false;
                browserHistory.undo = false;
                browserHistory.updateQuery = false,
                    browserHistory.urlParameterPending(false);
                browserHistory.waitForPopStateHandler(false);
                // data
                browserHistory.activePivots = {};
                browserHistory.pendingFormCloseStates = [];
                browserHistory.pendingUrlParameters = {};
                browserHistory.navigationHistory.clear();
                browserHistory.newHistoryState = {};
                browserHistory.queryMI = undefined;
            }
            browserHistory.init = init;
            function initialState() {
                // initialize browser HTML5 history
                // We are using a loading title string to avoid giving the appearance that the user could click it when looking at the browser history stack.
                document.title = $dyn.label("Shell_LoadingTitle");
                var state = { stackIndex: -1, historyIndex: -1, formName: "NoFormLoaded", placeHolderState: true };
                window.history.replaceState(state, null, null);
                document.title = $dyn.shell.ProductShortName();
            }
            browserHistory.initialState = initialState;
            /**
             * Prep work for writing a new state
             * @param targetElement create a new browser history state for this element.
             * @param options for updating the URL.
             */
            function createState(targetElement, options) {
                var currentForm = $dyn.context(targetElement);
                // Check if a second form is opened before the first finishes, push the newHistoryState to the browser history before starting the next newHistoryState
                if (!jQuery.isEmptyObject(browserHistory.newHistoryState)) {
                    browserHistory.write();
                }
                browserHistory.newHistoryState = {};
                browserHistory.newHistoryState.stackIndex = $dyn.shell._currentStackIndex;
                browserHistory.newHistoryState.formName = targetElement.getAttribute("data-dyn-form-name");
                browserHistory.newHistoryState.formID = targetElement.getAttribute("data-dyn-formid");
                browserHistory.newHistoryState.pivot = browserHistory.activePivots;
                if (options && options.preserveForm) {
                    browserHistory.newHistoryState.preserveForm = true;
                }
                if (options && options.path) {
                    browserHistory.newHistoryState.path = options.path;
                }
                else if (browserHistory.updateQuery) {
                    browserHistory.newHistoryState.path = $dyn.shell.getQueryStringForNewMenuItem(browserHistory.queryMI);
                    browserHistory.updateQuery = false;
                    browserHistory.queryMI = undefined;
                }
                else if ((currentForm) && ($dyn.value(currentForm.MenuItemName) !== "" && $dyn.value(currentForm.AllowRootNavigation))) {
                    browserHistory.newHistoryState.path = $dyn.shell.getQueryStringForNewMenuItem($dyn.value(currentForm.MenuItemName));
                }
                browserHistory.newStatePending(true);
                $dyn.log.navigation && $dyn.log.navigation("Navigation: BrowserHistory -> created new history state for form %s .", browserHistory.newHistoryState.formName);
            }
            browserHistory.createState = createState;
            /**
             * Attempt to close the primary form at the top of the shell navigation stack by calling the form's Close function.
             * The form is not required to be the active form.
             */
            function requestClose() {
                var thisForm = $dyn.context($dyn.shell.stack()[$dyn.length($dyn.shell.stack) - 1]);
                if (thisForm) {
                    if ($dyn.value(thisForm.FormName) === "DefaultDashboard") {
                        $dyn.log.navigation && $dyn.log.navigation("Navigation: form.Close for form: " + $dyn.value(thisForm.FormName));
                    }
                    $dyn.log.navigation && $dyn.log.navigation("Navigation: form.Close for form: " + $dyn.value(thisForm.FormName));
                    $dyn.applyFunction(thisForm.Close);
                }
                else {
                    if (browserHistory.goingBack) {
                        $dyn.log.navigation && $dyn.log.navigation("Navigation: Shell was requested to close a form that was already closed.");
                        browserHistory.completeBackNavigation();
                    }
                    else {
                        $dyn.log.navigation && $dyn.log.navigation("Navigation: Error, Shell attempted to close the top primary form, but no form was found.");
                        // throw error?  Task 880464 : Error handling during navigation
                    }
                }
            }
            browserHistory.requestClose = requestClose;
            /**
             * If form.requestClose() fails, we need to correct the shell and browser state.
             */
            function failedClose() {
                if ($dyn.shell.isClosingOpenForms) {
                    // Navigation to the new root level form is prevented until the work in progress is completed
                    $dyn.shell.isClosingOpenForms = false;
                    $dyn.user().updateCompany($dyn.util.parseQueryString(window.location.search)[$dyn.shell.QueryStringKeys.companyKey.toLowerCase()]);
                    $dyn.shell.closingAllCallback = undefined;
                    if (typeof ($dyn.shell.closingErrorCallback) === "function") {
                        $dyn.shell.closingErrorCallback();
                    }
                    $dyn.shell.closingErrorCallback = undefined;
                    var index_1 = $dyn.length($dyn.shell.stack) - 1;
                    // remove the cached navigationHistory
                    while ($dyn.length($dyn.shell.browserHistory.navigationHistory) > 0 &&
                        $dyn.value($dyn.shell.browserHistory.navigationHistory)[$dyn.length($dyn.shell.browserHistory.navigationHistory) - 1].stackIndex > index_1) {
                        $dyn.log.navigation && $dyn.log.navigation("Navigation: navigationHistory.pop() from failedClose - isClosingOpenForms.");
                        $dyn.shell.browserHistory.navigationHistory.pop();
                    }
                    $.when($dyn.deferred.onTrue(function () {
                        return $dyn.value($dyn.async.pending) === 0;
                    })).done(function () {
                        if (index_1 >= 0) {
                            $dyn.shell.activateElement($dyn.value($dyn.shell.stack)[index_1]);
                        }
                        else {
                            // no form to go to, so go home
                            $dyn.shell.goHome();
                            index_1 = 0;
                        }
                        $dyn.shell._currentStackIndex = index_1;
                        $dyn.shell.browserHistory.clearForward();
                        $dyn.shell.resetShellOnNavigation();
                        $dyn.error({ Message: $dyn.label("Shell_AbortedNavigation"), Label: "Shell_AbortedNavigation" });
                    });
                }
                else {
                    // The user had requested close via the back button.  Replace the browser and shell history and cancel any further pending form closures.
                    var tempState = void 0;
                    while (this.pendingFormCloseStates.length > 0) {
                        tempState = this.pendingFormCloseStates.pop();
                        $dyn.log.navigation && $dyn.log.navigation("Navigation: navigationHistory.push failedClose");
                        this.navigationHistory.push(tempState);
                        history.pushState(tempState, null, null);
                    }
                    $(document).trigger("updateUtilLocationQuery");
                    this.goingBack = false;
                    this.isExiting = false;
                }
            }
            browserHistory.failedClose = failedClose;
            /**
             * Add entity page view or tab page to the browser history when the pivot control is initialized
             * @param control pivot control.
             */
            function addPivot(control) {
                var activeItemName = control.activeItemName();
                if (activeItemName.length > 0 && control.Root) {
                    browserHistory.pivotEvaluationPending++;
                    $dyn.observe(control.Root.ReadyState, function (readyState) {
                        if (readyState === $dyn.ui.ReadyState.ready ||
                            readyState === $dyn.ui.ReadyState.closed ||
                            readyState === $dyn.ui.ReadyState.aborted) {
                            browserHistory.pivotEvaluationPending--;
                            if (readyState === $dyn.ui.ReadyState.ready &&
                                browserHistory.activePivots[control.Name] !== activeItemName &&
                                $dyn.value(control.IsPageView)) {
                                browserHistory.activePivots[control.Name] = activeItemName;
                                browserHistory.newStatePending(true);
                            }
                            return false;
                        }
                    });
                }
            }
            browserHistory.addPivot = addPivot;
            /**
             * Prepare to post a new browser history entry when the active tab (or entity page view) is changed
             * @param control pivot control.
             */
            function changePivot(control) {
                if (control.activeItemName().length > 0) {
                    // only retrieve the activePivots if this is the first update being made before writing the browser history.
                    if (jQuery.isEmptyObject(browserHistory.activePivots) && history && history.state) {
                        browserHistory.activePivots = jQuery.extend(true, {}, history.state.pivot);
                    }
                    browserHistory.addPivot(control);
                }
            }
            browserHistory.changePivot = changePivot;
            /**
             * Clear the client pivot record (will defer to browser history state object, not the local client/cached copy)
             */
            function clearPivots() {
                browserHistory.activePivots = {};
            }
            browserHistory.clearPivots = clearPivots;
            /**
             * Duplicate current browser history record, clears all forward history with a pushState
             * the browser history acts as if we have navigated to a "new" page so discards the old "forward" portion of the browser navigation stack
             */
            function clearForward() {
                if (!browserHistory.duplicateRecord) {
                    // standard document.title updater waits for $dyn.ui.updating, need to set the title before we duplicate the history record.
                    $dyn.shell.setDocumentTitle($dyn.shell.primaryFormCaption());
                    $dyn.log.navigation && $dyn.log.navigation("Navigation: push null state to clear forward");
                    window.history.pushState(history.state, null, null);
                    browserHistory.duplicateRecord = true;
                    browserHistory.clearPivots();
                    // sync the internal query values with the url values due to clearing navigation out
                    $(document).trigger("updateUtilLocationQuery");
                }
            }
            browserHistory.clearForward = clearForward;
            /**
             * Add an entry to the browser navigation history
             */
            function write() {
                // For the case of a logical form change (tab page) we need to copy the history entry
                if (jQuery.isEmptyObject(browserHistory.newHistoryState)) {
                    browserHistory.newHistoryState = jQuery.extend(true, {}, history.state);
                    browserHistory.newHistoryState.path = window.location.search;
                    browserHistory.newHistoryState.preserveForm = true;
                }
                browserHistory.newHistoryState.pivot = browserHistory.activePivots;
                if (browserHistory.goingBack) {
                    browserHistory.goingBack = false;
                }
                else {
                    var path = browserHistory.newHistoryState.path ? browserHistory.newHistoryState.path : null; // needs to be null, not undefined for history API.
                    browserHistory.newHistoryState.historyIndex = $dyn.length(browserHistory.navigationHistory); // length gives us a +1 increment
                    $dyn.log.navigation && $dyn.log.navigation("Navigation: navigationHistory.push write");
                    browserHistory.navigationHistory.push(browserHistory.newHistoryState);
                    if (browserHistory.duplicateRecord) {
                        $dyn.log.navigation && $dyn.log.navigation("Navigation: replace state for duplicate record");
                        history.replaceState(browserHistory.newHistoryState, null, path);
                        browserHistory.duplicateRecord = false;
                    }
                    else {
                        $dyn.log.navigation && $dyn.log.navigation("Navigation: push new state");
                        history.pushState(browserHistory.newHistoryState, null, path);
                    }
                    $(document).trigger("updateUtilLocationQuery");
                }
                if (browserHistory.newStatePending()) {
                    browserHistory.newStatePending(false);
                    browserHistory.pivotEvaluationPending = 0;
                }
                $dyn.log.navigation && $dyn.log.navigation("Navigation: BrowserHistory -> Adding to history with form %s, the new stack height will be: %d.", browserHistory.newHistoryState.formName, browserHistory.newHistoryState.stackIndex + 1);
                $dyn.shell.setDocumentTitle($dyn.shell.primaryFormCaption());
                browserHistory.clearPivots();
                browserHistory.newHistoryState = {};
            }
            browserHistory.write = write;
            /**
             * After closing a client form, confirm if there are outstanding close requests or if the browser history needs to be adjusted
             */
            function completeBackNavigation() {
                if (browserHistory.goingBack) {
                    // browser back was already called, current history state should be activated
                    browserHistory.pendingFormCloseStates.shift();
                    var state = history.state;
                    if (state) {
                        var activatingIndex = state.stackIndex;
                        var targetElement = $dyn.shell.stack()[activatingIndex];
                        // verify the form we are trying to activate wasn't already closed.
                        if (!targetElement) {
                            if (browserHistory.pendingFormCloseStates.length === 0) {
                                if ($dyn.shell.canGoBack()) {
                                    $dyn.shell.trimStack(activatingIndex);
                                    $dyn.shell.browserHistory.goToPreviousFormPending(true);
                                    return;
                                }
                                else {
                                    $dyn.shell.restartNavigationStack();
                                }
                            }
                        }
                        else {
                            if (targetElement !== $dyn.shell.getActiveForm()) {
                                $dyn.shell.activateElement(targetElement);
                                $dyn.shell._currentStackIndex = activatingIndex;
                            }
                            if (Object.keys(state.pivot).length !== 0 && targetElement.getAttribute("id")) {
                                var form = $dyn.context(targetElement);
                                if (form && $dyn.value(form.ShowLinkToGridView) && form.OpenGridView) {
                                    $dyn.getFunction(form.OpenGridView)();
                                }
                                else {
                                    Object.keys(state.pivot).forEach($dyn.shell.selectTabs, state.pivot);
                                }
                            }
                        }
                    }
                    // remove pending states that don't require closing forms.
                    while (browserHistory.pendingFormCloseStates.length > 0 &&
                        browserHistory.pendingFormCloseStates[0].preserveForm) {
                        browserHistory.pendingFormCloseStates.shift();
                    }
                    if (browserHistory.pendingFormCloseStates.length > 0) {
                        // close the next form pending to be closed
                        browserHistory.requestClose();
                    }
                    else {
                        browserHistory.clearForward();
                        browserHistory.goingBack = false;
                        $dyn.shell.resetShellOnNavigation();
                        if ($dyn.shell.isCurrentFormDefaultForm()) {
                            $.when($dyn.deferred.onTrue(function () {
                                return $dyn.value($dyn.async.pending) === 0;
                            })).done(function () {
                                $dyn.shell.refreshData(false);
                            });
                        }
                    }
                }
                else {
                    if ($dyn.shell.isClosingOpenForms) {
                        $dyn.log.navigation && $dyn.log.navigation("Navigation: navigationHistory.pop() from completeBackNavigation - isClosingOpenForms");
                        var tempState = browserHistory.navigationHistory.pop();
                        if (tempState) {
                            var count = 1;
                            var newState = $dyn.value(browserHistory.navigationHistory)[$dyn.length(browserHistory.navigationHistory) - 1];
                            while (newState && newState.stackIndex === tempState.stackIndex) {
                                // We could have multiple browserHistory entries for multiple logical views of the same modeled form.
                                $dyn.log.navigation && $dyn.log.navigation("Navigation: navigationHistory.pop() from completeBackNavigation - isClosingOpenForms - while");
                                $dyn.shell.browserHistory.navigationHistory.pop();
                                newState = $dyn.value(browserHistory.navigationHistory)[$dyn.length(browserHistory.navigationHistory) - 1];
                                count++;
                            }
                            $dyn.shell.browserHistory.undo = true;
                            // The emitting of the popstate event is not synchronous in Chrome, so wait for it to be called in certain scenarios
                            $dyn.shell.browserHistory.waitForPopStateHandler(true);
                            history.go(-count);
                        }
                    }
                    else if ($dyn.shell.canGoBack()) {
                        $dyn.log.navigation && $dyn.log.navigation("Navigation: completeBackNavigation with server initiated close.");
                        $dyn.shell.browserHistory.goToPreviousFormPending(true);
                    }
                    else if ($dyn.value($dyn.shell.browserHistory.newStatePending)) {
                        $dyn.log.navigation && $dyn.log.navigation("Navigation: a close was initiated while we were waiting to write a new state.");
                        var subscriberId_1 = $dyn.shell.browserHistory.newStatePending.valueChanged.subscribe(function (newValue) {
                            if (!$dyn.value(newValue)) {
                                $dyn.shell.browserHistory.goToPreviousFormPending(true);
                                $dyn.shell.browserHistory.newStatePending.valueChanged.unsubscribe(subscriberId_1);
                            }
                        });
                    }
                }
            }
            browserHistory.completeBackNavigation = completeBackNavigation;
            function activeFormHasMultipleReferences() {
                if (browserHistory.navigationHistory && $dyn.length(browserHistory.navigationHistory) > 1) {
                    var index = browserHistory.navigationHistory()[$dyn.length(browserHistory.navigationHistory) - 1].stackIndex;
                    return browserHistory.checkForReferences(index);
                }
                return false;
            }
            browserHistory.activeFormHasMultipleReferences = activeFormHasMultipleReferences;
            function checkForReferences(index) {
                for (var i = $dyn.length(browserHistory.navigationHistory) - 2; i >= 0; i--) {
                    // -2 because we should ignore the top (the current position)
                    if (browserHistory.navigationHistory()[i].stackIndex === index) {
                        return true;
                    }
                }
                return false;
            }
            browserHistory.checkForReferences = checkForReferences;
            /**
             * Remove extra navigation history entries to the active form if it has multiple views.
             * @param index index number for which history has to be removed.
             */
            function removeExtraNavigationHistoryEntries(index) {
                $dyn.log.navigation && $dyn.log.navigation("Navigation: removeExtraNavigationHistoryEntries called.");
                var count = 0;
                for (var i = $dyn.length(browserHistory.navigationHistory) - 2; i >= 0; i--) { // -2 because we should ignore the top (the current position)
                    if (browserHistory.navigationHistory()[i].stackIndex === index) {
                        $dyn.log.navigation && $dyn.log.navigation("Navigation: navigationHistory.pop() from removeExtraNavigationHistoryEntries.");
                        browserHistory.navigationHistory.pop();
                        count++;
                    }
                    else {
                        break;
                    }
                }
                if (count !== 0) {
                    $dyn.log.navigation && $dyn.log.navigation("Navigation: Removed %s extra history entries.", count);
                    // Inform the popstate handler that this browser navigation event isn't a request to do further actions.
                    $dyn.shell.browserHistory.undo = true;
                    // The emitting of the popstate event is not synchronous in Chrome, so wait for it to be called in certain scenarios
                    $dyn.shell.browserHistory.waitForPopStateHandler(true);
                    history.go(-count); // history.go will emit a popstate event
                }
            }
            browserHistory.removeExtraNavigationHistoryEntries = removeExtraNavigationHistoryEntries;
            function backNavigationTelemetry(count) {
                var destinationFormName = "";
                if (history.state && history.state.formName) {
                    destinationFormName = history.state.formName;
                }
                var originatingForm = $dyn.context($dyn.shell.getActiveForm());
                var eventOptions = {
                    extendedData: destinationFormName,
                    userDefined1: Number(browserHistory.backNavigationInitiatedByBrowser),
                    userDefined2: count
                };
                $dyn.telemetry.addFormActionEvent(originatingForm, $dyn.telemetry.ActionEvents.backNavigation, eventOptions);
                $dyn.shell.browserHistory.backNavigationInitiatedByBrowser = true;
            }
            browserHistory.backNavigationTelemetry = backNavigationTelemetry;
            // Waiting for async.pending allows a new form and multiple tab/pivots to be activated by a single user interaction.  All will be caught with one browser history entry.
            // Writing new history will take precedence over deleting old history.  To avoid nested timeouts and priority ordering,
            // old history will remain in place until we attempt to activate the old form, at which time we will remove it and automatically go back again.
            $dyn.observe($dyn.options(function () {
                return {
                    goToPreviousFormPending: browserHistory.goToPreviousFormPending,
                    newStatePending: browserHistory.newStatePending,
                    urlParameterPending: browserHistory.urlParameterPending
                };
            }, $dyn.async.pending), function (options) {
                $dyn.log.navigation && $dyn.log.navigation("Navigation: browser history operation will be triggered with newStatePending: %s, goToPreviousFormPending: %s, and urlParameterPending: %s.", options.newStatePending, options.goToPreviousFormPending, options.urlParameterPending);
                if (options.goToPreviousFormPending) {
                    browserHistory.goToPreviousFormPending._current = false;
                    $dyn.log.navigation && $dyn.log.navigation("Navigation: navigationHistory.pop() from async pending.");
                    browserHistory.navigationHistory.pop();
                    browserHistory.waitForPopStateHandler(true);
                    if (options.newStatePending) {
                        browserHistory.undo = true;
                    }
                    else {
                        browserHistory.revert = true;
                    }
                    history.back();
                }
                if (options.newStatePending) {
                    $dyn.observe(browserHistory.waitForPopStateHandler, function (value) {
                        if (!value) {
                            $dyn.log.navigation && $dyn.log.navigation("Navigation: navigationHistory.write() from async pending.");
                            if (browserHistory.goingBack) {
                                browserHistory.goingBack = false;
                            }
                            browserHistory.write();
                            return false;
                        }
                    });
                }
                if (options.urlParameterPending) {
                    if (!options.goToPreviousFormPending) {
                        $dyn.shell._updateUrlParameters(browserHistory.pendingUrlParameters);
                    }
                    browserHistory.pendingUrlParameters = {};
                    browserHistory.urlParameterPending._current = false;
                }
            });
            // Note that popstate events only happen for history.go or history.back not history.pushstate or history.replacestate
            // Note that popstate event is async for chrome
            window.addEventListener("popstate", function (event) {
                var retVal = $dyn.shell.navigationPopstateHandler(event);
                $dyn.shell.browserHistory.waitForPopStateHandler(false);
                return retVal;
            });
        })(browserHistory = shell.browserHistory || (shell.browserHistory = {}));
    })(shell = $dyn.shell || ($dyn.shell = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=BrowserHistory.js.map
